// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__ckO1F","unreadBadge":"styles_unreadBadge__3GbDF","modalContent":"styles_modalContent__1Zg1m","modal":"styles_modal__1sGKg"};